import logoutLogo from "src/assets/logout.png";

const UserNotFound = () => {
  return (
    <div className="flex flex-col justify-center items-center h-[100vh]">
      <img src={logoutLogo} alt="" className="h-[350px]" />
      <h2 className="text-[32px] font-semibold"> You have been logged out</h2>
      <p className="text-[15px] font-semibold text-[#76767CCC] mt-1">Please login again to view chats</p>
    </div>
  );
};

export default UserNotFound;
